import type OtpSettings from 'owa-service/lib/contract/OtpSettings';
import type { BookingEmailVerificationMethod } from 'owa-graph-schema';
import type BookingEmailVerificationMethodEnum from '../../constants/bookingEmailVerificationMethodEnum';
import type FeatureSource from '../../constants/source';

const mapOtpSettingsToBookingEmailVerificationMethod = (
    otpSetting: OtpSettings | undefined,
    source?: string
): BookingEmailVerificationMethod | undefined => {
    if (otpSetting === undefined) {
        return;
    }

    if (source === 'BookWithMe') {
        // In model A otpSetting is always Default and EmailVerification method is Otp for BwM so keeping it same.
        return 'Otp';
    }

    switch (otpSetting) {
        case 1:
            return 'Disabled';
        case 2:
            return 'Otp';
        default:
            return 'Undefined';
    }
};

export default mapOtpSettingsToBookingEmailVerificationMethod;
